module.exports = __webpack_public_path__ + "img/goto_icon.613999da.svg";